import { Button } from '../ui/button';
import { Loader2 } from 'lucide-react';

interface PrimaryButtonProps extends React.ComponentProps<typeof Button> {
  isLoading?: boolean;
  preIcon?: React.ReactNode;
}

export const PrimaryButton: React.FC<PrimaryButtonProps> = ({ children, className, isLoading, preIcon, disabled, ...props }) => {
  return (
    <Button
      className={`px-4 py-3 bg-jen-orange rounded-lg text-[#fff] h-[44px] hover:opacity-80 hover:bg-jen-orange flex items-center ${className}`}
      disabled={isLoading || disabled}
      {...props}
    >
      {isLoading ? <Loader2 className="mr-1 h-4 w-4 animate-spin" /> : preIcon}
      {children}
    </Button>
  );
};

export const SecondaryButton: React.FC<React.ComponentProps<typeof Button>> = ({ children, className, ...props }) => {
  return (
    <Button
      className={` px-4 py-3 bg-[#fff] rounded-lg border border-jen-disabled text-jen-content-primary h-[44px] hover:bg-[#fff] hover:opacity-80 ${className}`}
      {...props}
    >
      {children}
    </Button>
  );
};
